import React from "react";

import "./SearchControl.scss";

import SearchIcon from "./images/icons/search.svg?react";
import ResetIcon from "@/common/images/icons/x.svg?react";

type Props = {
  placeholder: string;
  value?: string;
  onChange: (value: string) => void;
}

export const SearchControl: React.FC<Props> = ({ placeholder, value = "", onChange }) => {
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  const handleReset = () => {
    onChange("");
  };

  return (
    <div className="searchControl">
      <SearchIcon className="searchIcon" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      {value && (
        <button className="resetSearchButton" onClick={handleReset} aria-label="Clear search">
          <ResetIcon className="resetIcon" />
        </button>
      )}
    </div>
  );
};
